import api from '../api'

export const postPlan = (params) => api.post('/companies/plans', params)

export const putPlan = (params) => api.put(`/companies/plans/${ params.id }`, params)

export const deletePlan = (params) => api.delete(`/companies/plans/${ params.id }`)
